import React, { useState } from "react";
import Slider from "react-slick";

// Components //
import RichtextDescription from "../../atoms/richtext-description/richtextDescription";

// Interfaces //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Styles //
import "./benefits.scss";

const Benefits = (props: ReferenciaContenido) => {
    const {
        tituloGeneral,
        descripcion,
        imagenPrincipal,
        referenciaPlantillaContenido: refPlantilla,
    } = props;
    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState(0);

    const CarouselBenefits = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        beforeChange: (_: number, next: number) => setSliderIndex(next),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const goToNext = () => {
        if (sliderIndex < refPlantilla.length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const isActiveBack = () => sliderIndex > 0;

    const isActiveNext = () => sliderIndex < refPlantilla.length - 1;

    return (
        <div className="o-benefits">
            <div className="container">
                <div className="o-benefits__container">
                    <div className="benefits-banner">
                        <div className="benefits-banner__title">
                            <h2>{tituloGeneral}</h2>
                            {descripcion && (
                                <RichtextDescription {...descripcion} />
                            )}
                        </div>
                        <div className="benefits-banner__image">
                            <img src={imagenPrincipal.file.url} alt="Comfama" />
                        </div>
                    </div>
                    <div className="benefits-carousel">
                        <div className="benefits-carousel__container">
                            <Slider
                                ref={(c) => {
                                    setSlider(c);
                                }}
                                {...CarouselBenefits}
                            >
                                {props.nombreCategoria && props.nombreCategoria === "Empresas" && refPlantilla.map((item, i) => (
                                    <div
                                        className="benefits-carousel__item"
                                        key={i}
                                    >
                                        <div className="benefits-carousel__item__header">
                                            <span>{i + 1}</span>
                                            <h3>{item.tituloBanner}</h3>
                                        </div>
                                        <div className="benefits-carousel__item__body">
                                            <RichtextDescription
                                                {...item.descripcion}
                                            />
                                        </div>
                                    </div>
                                )) }
                                {props.nombreCategoria && props.nombreCategoria === "Personas" && refPlantilla.map((item, i) => (
                                    <div
                                        className="benefits-carousel__item"
                                        key={i}
                                    >
                                        <span>{i + 1}</span>
                                        <RichtextDescription
                                            {...item.descripcion}
                                        />
                                    </div>
                                )) }
                            </Slider>
                            <span
                                className={`arrow icon-chevron-left ${
                                    isActiveBack() ? "active" : ""
                                }`}
                                onClick={goToBack}
                            ></span>
                            <span
                                className={`arrow icon-chevron-right ${
                                    isActiveNext() ? "active" : ""
                                }`}
                                onClick={goToNext}
                            ></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Benefits;
